import enLocale from './en'
import zhLocale from './zh'

const localeMessages = {
  en: {
    ...enLocale
  },
  zh: {
    ...zhLocale
  }
}

export default localeMessages
